<template>
  <div>
    <ts-page-title
      :title="$t('user.pageTitle')"
      :breadcrumb="[
        { text: $t('home'), href: '/' },
        {
          text: $t('user.pageTitle'),
          active: true,
        },
      ]"
    />
    <ts-panel>
      <ts-panel-wrapper>
        <div class="tw-flex tw-justify-between tw-items-center">
          <a-button
            type="primary"
            @click="$router.push({ name: 'user-create' })"
          >
            {{ $t("addNew") }}
          </a-button>
          <div class="tw-justify-end tw-space-x-2">
            <a-input-search
              v-model="search"
              :placeholder="$t('user.search')"
              style="width: 200px"
            />
            <a-button v-tooltip="$t('filter')" @click.prevent="visible = true">
              <i class="fa fa-filter"></i>
            </a-button>
            <!-- <ts-button
              v-tooltip="$t('filter')"
              @click.prevent="visible = true"
              class="tw-h-8 tw-mt-0"
            >
              <i class="fa fa-filter"></i>
            </ts-button> -->
          </div>
        </div>
      </ts-panel-wrapper>
      <div class="tw-overflow-auto">
        <ts-table :columns="columns" :records="resources" :loading="loading">
          <template v-slot="{ record }">
            <td>{{ record.user_name }}</td>
            <td>
              {{ record.employee ? record.employee.employee_name_en : "" }}
            </td>
            <td class="tw-text-center">
              {{ record.employee ? record.employee.branch.prefix_code : "" }}
            </td>
            <td>
              <span
                class="badge bg-primary tw-mr-2 tw-capitalize"
                v-for="(role, index) in record.roles"
                :key="index"
                >{{ role.name == "*" ? "Everything" : role.name }}</span
              >
            </td>
            <td class="tw-text-center">
              <span class="badge bg-blue tw-mr-1 tw-capitalize">{{
                defaulBranch(record.branches)
              }}</span>
            </td>
            <td class="tw-w-32 tw-text-center">
              <span class="badge bg-success" v-if="!record.disable">Yes</span>
              <span class="badge bg-danger" v-else>No</span>
            </td>
            <td class="tw-text-center">{{ record.created_at }}</td>
            <td class="tw-text-center">{{ record.updated_at }}</td>
            <td class="text-center">
              <a
                href="#"
                class="mr-2 text-primary"
                @click.prevent="onEdit(record)"
              >
                <i class="fa fa-edit"></i>
              </a>
            </td>
          </template>
        </ts-table>
      </div>
      <div class="d-flex justify-content-end tw-p-4">
        <ts-pagination
          v-model="pagination"
          @navigate="fetchData"
        ></ts-pagination>
      </div>
    </ts-panel>
    <a-drawer
      :title="$t('filter')"
      :closable="false"
      :visible="visible"
      @close="() => (visible = false)"
      width="300px"
    >
      <div class="mb-3">
        <label class="form-col-label control-label">{{
          $t("testingCenter")
        }}</label>
        <ts-branch-filter @filter="(value) => (branch_id = value)" />
      </div>
      <div class="mb-3">
        <ts-checkbox v-model="disable" @change="fetchData()"
          >Is Disable</ts-checkbox
        >
      </div>
    </a-drawer>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { debounce } from "lodash";
export default {
  name: "userIndex",
  data() {
    return {
      visible: false,
      loading: false,
      branch_id: [],
    };
  },
  computed: {
    ...mapState("auth/user", ["resources", "pagination"]),
    search: {
      get() {
        return this.$store.state.auth.user.search;
      },
      set(newValue) {
        this.$store.commit("auth/user/SET_SEARCH", newValue);
        this.$store.commit("auth/user/RESET_CURRENT_PAGE");
      },
    },
    disable: {
      get() {
        return this.$store.state.auth.user.disable;
      },
      set(newValue) {
        this.$store.commit("auth/user/SET_STATUS", newValue);
      },
    },
    columns() {
      return [
        { name: this.$t("user.userName") },
        { name: this.$t("user.employeeName") },
        {
          name: this.$t("user.testingCenter"),
          style: "text-align:center",
        },
        { name: this.$t("user.roleName") },
        {
          name: this.$t("user.defaultTestingCenter"),
          style: "text-align:center",
        },
        {
          name: this.$t("user.active"),
          style: "text-align:center",
        },
        {
          name: this.$t("user.createAt"),
          style: "text-align:center",
        },
        {
          name: this.$t("user.updateAt"),
          style: "text-align:center",
        },
        {
          name: this.$t("actions"),
          style: "width:7%; text-align:center",
        },
      ];
    },
  },
  methods: {
    defaulBranch(branches) {
      return branches.find((b) => b.pivot.is_default == true)
        ? branches.find((b) => b.pivot.is_default == true).prefix_code
        : "";
    },
    fetchData(attributes) {
      this.loading = true;
      this.$store
        .dispatch("auth/user/fetch", {
          ...attributes,
          branch_id: this.branch_id,
        })
        .catch((error) => {
          this.loading = false;
          this.$toasted.error(error.message);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onEdit(record) {
      this.$store.commit("auth/user/SET_EDIT_DATA", record);
      this.$router.push({
        name: "user-edit",
        params: { id: record.user_id },
      });
    },
  },
  watch: {
    search: debounce(function (search) {
      this.fetchData({ search });
    }, 500),
    branch_id: debounce(function (value) {
      this.fetchData({ branch_id: value });
    }, 500),
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fetchData();
    });
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit("auth/user/RESET_STATE");
    next();
  },
};
</script>
